import { PaymentSourceStatus, PaymentSourceType } from 'common/types/enum'

export const getPaymentTypeText = (type: PaymentSourceType) => {
  switch (type) {
    case PaymentSourceType.CARD:
      return 'Card'
    case PaymentSourceType.PAYPAL_EXPRESS_CHECKOUT:
      return 'Paypal'
    case PaymentSourceType.DIRECT_DEBIT:
      return 'Direct Debit'
    case PaymentSourceType.AMAZON_PAYMENTS:
      return 'Amazon Pay'
    default:
      return 'Unknown'
  }
}

export const getPaymentStatusText = (status: PaymentSourceStatus) => {
  switch (status) {
    case PaymentSourceStatus.VALID:
      return 'Valid'
    case PaymentSourceStatus.EXPIRING:
      return 'Expiring'
    case PaymentSourceStatus.EXPIRED:
      return 'Expired'
    case PaymentSourceStatus.INVALID:
      return 'Invalid'
    case PaymentSourceStatus.PENDING_VERIFICATION:
      return 'Pending Verification'
    default:
      return 'Unknown'
  }
}
